import axios from "axios";
import { clearFormDraft } from "../utils/formStorage";
import {
  INVESTIGATION_FILE_FIELDS,
  normalizeInvestigationFiles,
} from "../utils/investigationFiles";

const url = process.env.REACT_APP_SERVER_URL || process.env.REACT_APP_API_URL;

/**
 * Build FormData from form state for multipart/form-data submission.
 * - File objects: appended as-is
 * - Arrays/objects: JSON.stringify
 * - Primitives: String(value)
 */
function buildFormData(data) {
  const formData = new FormData();

  for (const [key, value] of Object.entries(data)) {
    if (key === "appointmentId") continue;
    if (value === undefined || value === null) continue;

    if (INVESTIGATION_FILE_FIELDS.includes(key)) {
      const items = normalizeInvestigationFiles(value);
      const kept = items.filter((x) => typeof x === "string");
      const files = items.filter((x) => typeof File !== "undefined" && x instanceof File);
      formData.append(`${key}_kept`, JSON.stringify(kept));
      for (const f of files) {
        formData.append(key, f);
      }
      continue;
    }

    if (typeof File !== "undefined" && value instanceof File) {
      formData.append(key, value);
    } else if (Array.isArray(value) || (typeof value === "object" && value !== null && !(value instanceof Date))) {
      formData.append(key, JSON.stringify(value));
    } else {
      formData.append(key, String(value));
    }
  }

  if (data.appointmentId) {
    formData.append("appointmentId", String(data.appointmentId));
  }

  return formData;
}

/**
 * @param {object} data - form state + appointmentId
 * @param {{ saveProgressOnly?: boolean }} [options]
 *   - saveProgressOnly: true for Save/Exit (persist to DB, no notification emails)
 */
export const submitQuestionary = async (data, options = {}) => {
  const { saveProgressOnly = false } = options;
  console.log("Submitting data:", { saveProgressOnly, keys: Object.keys(data || {}) });

  try {
    const formData = buildFormData(data);
    if (saveProgressOnly) {
      formData.append("saveProgressOnly", "true");
    }

    await axios.post(
      `${url}/uploads/dicom/file/question`,
      formData
      // Do NOT set Content-Type - axios sets multipart/form-data with correct boundary
    );

    if (data.appointmentId) {
      clearFormDraft(data.appointmentId);
    }

    const PORTAL_URL = process.env.REACT_APP_PORTAL_URL || "https://portal-staging.spine-review.com";
    window.location = `${PORTAL_URL}/view-patient-booked-appointment`;
  } catch (error) {
    console.error("Error submitting questionnaire:", error.message);
    throw error;
  }
};

export const getQuestionaryByAppointmentId = async (appointmentId) => {
  try {
    const res = await axios.get(
      `${url}/admin/get-patient-form-preview?appointmentId=${appointmentId}`
    );

    if (res.data.success) {
      return res.data.data;
    }
    return null;
  } catch (error) {
    console.error("Error fetching questionnaire:", error.message);
    if (error.response?.status === 404) {
      return null;
    }
    throw error;
  }
};
